import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class FillInputByLabelInstruction extends Instruction {
  constructor ({ name, label, waitForNoLoaders, value, scope }) {
    super({ name, waitForNoLoaders, type: InstructionTypes.FillInputByLabel, scope })
    this.label = label
    this.value = value
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.value === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    throw new Error('Method not implemented.')
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      label: this.label,
      value: this.value
    }
  }
}
